import React, { createContext, useContext, useState, useEffect } from "react";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../Firebase/Firebase";

const UnreadMessageContext = createContext();

export const useUnreadMessages = () => useContext(UnreadMessageContext);

export const UnreadMessageProvider = ({ children }) => {
  const [hasUnreadMessages, setHasUnreadMessages] = useState(false);
  
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("Fiesta"));
    if (!userData?.id) return;
    
    const myId = userData.id.toString();
    
    // Listen to chat collection for any documents where the current user has unread messages
    const chatRef = collection(db, "chat");
    const unsubscribe = onSnapshot(query(chatRef), (snapshot) => {
      let hasUnread = false;
      
      snapshot.docs.forEach((doc) => {
        const data = doc.data();
        if (data.unReadCount && data.unReadCount[myId] > 0) {
          hasUnread = true;
        }
      });
      
      setHasUnreadMessages(hasUnread);
    });
    
    return () => unsubscribe();
  }, []);
  
  return (
    <UnreadMessageContext.Provider value={{ hasUnreadMessages }}>
      {children}
    </UnreadMessageContext.Provider>
  );
};